import { createDspFxNode } from './dspModule';
import { dspAssetUrl } from './dspAssetUrl';

const WORKLET_URL = dspAssetUrl('/audio/delayProcessor.js');
const workletLoads = new WeakMap();

export function createDelayNode(context, params = {}) {
  return createDspFxNode(context, {
    workletUrl: WORKLET_URL, processorName: 'cookup-delay', params, workletLoads
  });
}

export const sendDelayParams = (node, params) => {
  node?.port?.postMessage({ type: 'params', params });
};

export const resetDelay = (node) => {
  node?.port?.postMessage({ type: 'reset' });
};
